module.exports = __webpack_public_path__ + "static/img/J_channel_logo.a5f08f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/J_channel_logo.png
// module id = ZQlv
// module chunks = 0